import React from 'react';
import Select from 'react-select';
import { isNullOrUndefined } from '../../../store/storeFunctions';

export const CustomSelect = ({onChange, options, value, isMulti = false, isLoading, isSearchable = false, isClearable = false, placeholder = null}) => {
    const selectedValues = Array.isArray(value) ? value : isNullOrUndefined(value) ? [] : [value];

    const customStyles = {
        control: (provided) => ({
            ...provided,
            flexWrap: 'nowrap',
        }),
        valueContainer: (provided) => ({
            ...provided,
            flexWrap: 'nowrap',
            overflow: 'hidden',
            display: 'flex',
        }),
        singleValue: (provided) => ({
            ...provided,
            position: 'absolute',
            maxWidth: 'calc(100% - 40px)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        input: (provided) => ({
            ...provided,
            flexShrink: 0 
        })
    }; 
    return(
        <Select
        className="react-select-container"
        classNamePrefix="react-select"
                options={options}
                onChange={(val) => isNullOrUndefined(val) ? onChange(val) : isMulti
                    ? onChange(val.map((c) => c.value))
                    : onChange(val.value)
                }
                styles={customStyles}
                value={isMulti
                    ? options.filter((c) => selectedValues.includes(c.value))
                    : options.find((c) => c.value === selectedValues[0]) || null
                }
                isMulti={isMulti}
                isLoading={isLoading}
                isSearchable={isSearchable}
                placeholder={placeholder}
                isClearable={isClearable}
            />
        )
}